import { useState } from 'react';
import { toast } from 'react-toastify';
import Axios from '../utils/axiosInstance';

const useSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const signup = async (name,userName ,email, password,phoneNumber) => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}api/register/`;
      const response = await Axios.post(apiUrl, {name,username:userName, email,password,phone_number:phoneNumber, });
      if (response.status === 200 || response.status === 201) {
        toast.success("Signup successful!");
        return {success:true};
      } else {
        throw new Error(response.data.message || "Registration failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred.");
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { signup, loading, error };
};

export default useSignup;
